import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Watches URL for ?invite= codes anywhere on the marketing site and
// hands off to First Snap by storing a pending invite and redirecting.
export default function InviteRedirector() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const invite = params.get('invite');
      if (!invite) return;

      const step = params.get('step') || 'joinGroup';
      const forced = params.get('forced') || 'true';

      const payload = {
        source: 'UnauthenticatedInviteHandler',
        inviteCode: String(invite).trim(),
        flowType: 'group',
        step,
        forced: forced === 'true'
      };
      // Persist so First Snap can pick it up after redirect/auth
      localStorage.setItem('sbe_pending_invite', JSON.stringify(payload));
      localStorage.setItem('sbe_signup_invite_active', '1');

      // Clean URL and redirect to First Snap
      navigate('/first-snap', { replace: true });
    } catch {}
  }, [location.search, navigate]);

  return null;
}


